<template>
  <div class="text-align-center">
    <img :src="require('@cdn?273b49494922')" :style="{ width: width }" alt="" />
    <div class="fs14 c999">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'CmmNoData',
  props: {
    title: {
      type: String,
      default: () => {
        return '暂无数据'
      }
    },
    width: {
      type: String,
      default: () => {
        return '130px'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
